const KEY = "Deman-planing";
const DRAFT_SKU_CREATE_KEYS = "DRAFT";
import metaEnv from "../helper/metaEnv";
import LZString from "lz-string";
import { ISkuData } from "../compiler/global.interface";

export function loadBrowserState() {
    metaEnv.isDev && console.log("load BrowserState succesfully");
    try {
        const serializedState = localStorage.getItem(KEY);
        if (!serializedState) return undefined;
        return JSON.parse(serializedState);
    } catch (e) {
        return undefined;
    }
}

export async function saveBrowserState(state: any) {
    metaEnv.isDev && console.log("save BroserState ", state);
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem(KEY, serializedState);
    } catch (e) {
        // Ignore
    }
}

export function removeBrowserState(keyName?: string) {
    localStorage.removeItem(keyName || KEY);
}

// for draft creat sku only
export function saveSkuCreateDraft(value: ISkuData) {
    const valueJson = JSON.stringify(value);
    localStorage.setItem(DRAFT_SKU_CREATE_KEYS, LZString.compress(valueJson));
}

export function getSkuCreatDraft(): ISkuData | undefined {
    const valueCompressed = localStorage.getItem(DRAFT_SKU_CREATE_KEYS);
    if(!valueCompressed) return;
    const decompressValue = LZString.decompress(valueCompressed);
    return JSON.parse(decompressValue);
}

export function removeSkuCreatDraft() {
    localStorage.removeItem(DRAFT_SKU_CREATE_KEYS);
}
